export default __webpack_public_path__ + "static/media/sandra.42aa0140.jpg";